import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100%',
    border: '2px dashed #CECFCE',
    borderRadius: 5,

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& > h3': {
      maxWidth: '37rem',
      fontSize: '1.6rem',
      color: '#CECFCE',
    },

    '&:hover': {
      cursor: 'pointer',
    },

    '&[data-error=true]': {
      borderColor: theme.palette.error.main,
    },
  },
  selectedFiles: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',

    '& > h3': {
      flex: 1,
      textAlign: 'center',
      fontSize: '1.6rem',
      margin: '.5rem 1rem',
    },
    '& button': {
      marginRight: '1rem',
      height: 'min-content',
      color: '#CECFCE',
    },
  },
  errorMessage: {
    color: theme.palette.error.main,
    letterSpacing: '0.03333em',
  },
}))
